const TASK_BADGE_KEY = 'drs-task-number'

function readTaskNumber() {
  const value = Number(localStorage.getItem(TASK_BADGE_KEY) || 0)
  return Number.isNaN(value) ? 0 : value
}

function saveTaskNumber(value) {
  const nextValue = Number(value || 0)
  if (nextValue > 0) {
    localStorage.setItem(TASK_BADGE_KEY, String(nextValue))
  } else {
    localStorage.removeItem(TASK_BADGE_KEY)
  }
}

function getTaskId(payload) {
  if (payload === undefined || payload === null) return ''
  if (typeof payload === 'object') return payload.taskId || payload.id || ''
  return payload
}

export default {
  state: {
    taskNumber: readTaskNumber(),
    exportTaskIds: []
  },
  getters: {
    taskNumber(state) {
      return state.taskNumber
    },
    exportTaskIds(state) {
      return state.exportTaskIds
    }
  },
  mutations: {
    setTaskNumber(state, value) {
      state.taskNumber = Number(value || 0)
      saveTaskNumber(state.taskNumber)
    },
    increaseTaskNumber(state) {
      state.taskNumber = Number(state.taskNumber || 0) + 1
      saveTaskNumber(state.taskNumber)
    },
    clearTaskNumber(state) {
      state.taskNumber = 0
      saveTaskNumber(0)
    },
    addExportTaskId(state, payload) {
      const taskId = getTaskId(payload)
      if (!taskId || state.exportTaskIds.some(id => String(id) === String(taskId))) return
      state.exportTaskIds.push(taskId)
    },
    removeExportTaskIds(state, taskIds) {
      const completedIds = (taskIds || []).map(String)
      state.exportTaskIds = state.exportTaskIds.filter(id => completedIds.indexOf(String(id)) === -1)
    }
  },
  actions: {
    markTaskCreated({ commit }, task) {
      commit('increaseTaskNumber')
      commit('addExportTaskId', task)
    },
    clearTaskBadge({ commit }) {
      commit('clearTaskNumber')
    },
    removeCompletedExportTasks({ commit }, taskIds) {
      commit('removeExportTaskIds', taskIds)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/task.js